module.exports = __webpack_public_path__ + "img/allgemeine-struktur.4f542488.png";